import AgencyFormBookingNr from "./components/form.agency.bookingnr.m";
import AgencyLoginResult from "./components/form.agency.result.m";
import Layout from "../shared/components/layout/layout.wide.m";
import ContactWaysQuestion from "./components/form.contact.m";
import AgencyLoginForm from "./components/form.agency.m";
import { unauth } from "../../shared/functions/booking";
import UserAndPhxLoginForm from "./components/form.m";
import UserLastLogins from "./components/last-logins.m";
import GetToKnow from "./components/gettoknow.m";
import { getWebtexte } from "./shared/functions";
import { Usertypes } from "./shared/usertypes";
import Canceled from "./components/canceled.m";
import Failure from "./components/error.m";
import Intro from "./components/intro.m";
import Page from "./components/page.m";
import Context from "./shared/context";
import Wip from "./components/wip.m";
import Config from "../../config";
import App from "../../bootstrap";
import m from "mithril";
import "./index.scss";
(() => {
    App.init("Login");
    App.initServiceWorker();
    if (!App.storageAvailable()) {
        m.render(document.body.querySelector("#root"), m(Page, { key: "storage-alert" }, [m(Intro)]));
        return;
    }
    getWebtexte()
        .then((result) => {
        Context.webtexte = result;
    })
        .catch((e) => {
        console.error(e);
        location.href = Config.urls.API_ERROR;
    })
        .finally(() => {
        m.redraw();
    });
    m.route(document.body.querySelector("#root"), "/", {
        "/": {
            render: () => [m(Page, [m(Intro)])],
        },
        "/kunde": {
            onmatch: () => unauth(),
            render: () => [
                m(Page, { userType: Usertypes.CUSTOMER }, [m(UserAndPhxLoginForm)]),
            ],
        },
        "/kunde/:rechnr/:name": {
            onmatch: () => unauth(),
            render: () => [
                m(Page, { userType: Usertypes.CUSTOMER }, [
                    m(UserAndPhxLoginForm, {
                        prefilled: true,
                        showAdvice: true,
                        isLastLogin: false,
                        triggerSubmit: false,
                    }),
                ]),
            ],
        },
        "/kunde/anmeldung/:rechnr/:name": {
            onmatch: () => unauth(),
            render: () => [
                m(Page, { userType: Usertypes.CUSTOMER }, [
                    m(UserAndPhxLoginForm, {
                        prefilled: true,
                        showAdvice: false,
                        isLastLogin: true,
                        triggerSubmit: true,
                    }),
                ]),
            ],
        },
        "/kunde/letzte-anmeldungen": {
            onmatch: () => unauth(),
            render: () => [
                m(Page, { userType: Usertypes.CUSTOMER }, [m(UserLastLogins)]),
            ],
        },
        "/agentur": {
            onmatch: () => unauth(),
            render: () => [
                m(Page, { userType: Usertypes.AGENCY }, [m(AgencyLoginForm)]),
            ],
        },
        "/agentur/:agencynr/:jwt": {
            onmatch: () => unauth(),
            render: () => [
                m(Page, {
                    userType: Usertypes.AGENCY,
                    key: m.route.param("agencynr"),
                }, [m(AgencyLoginResult)]),
            ],
        },
        "/agentur/stellvertretung": {
            render: () => [m(Page, [m(AgencyFormBookingNr)])],
        },
        "/mitarbeiter/kontakt": {
            render: () => [m(Page, [m(ContactWaysQuestion)])],
        },
        "/abgesagt": {
            render: () => [m(Page, [m(Canceled)])],
        },
        "/kennenlernen": {
            render: () => [
                m(Layout, {
                    noNav: true,
                    noAvatar: true,
                    noLogoutBtn: true,
                    noBackButton: true,
                }, [m(GetToKnow)]),
            ],
        },
        "/fehler": {
            render: () => [m(Page, { key: "error" }, [m(Failure)])],
        },
        "/wartung": {
            onmatch: () => unauth(),
            render: () => [m(Page, { key: "wip" }, [m(Wip)])],
        },
    });
})();
